module.exports = __webpack_public_path__ + "media/images/ohap_search-bfb1f0161330e2e236812c49c9d27613.png";